import type { Toast as ToastType } from '@/contexts/ToastContext';
import styles from './Toast.module.css';

const VARIANT_ICONS: Record<ToastType['variant'], string> = {
  success: '✓',
  error: '✕',
  info: 'ℹ',
  warning: '⚠',
};

interface ToastListProps {
  toasts: ToastType[];
  onDismiss(id: string): void;
}

export function ToastList({ toasts, onDismiss }: ToastListProps) {
  if (toasts.length === 0) return null;

  return (
    <div className={styles.container} role="status" aria-live="polite">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles.toast} ${styles[toast.variant]}`}
          role="alert"
        >
          <span className={styles.icon} aria-hidden="true">
            {VARIANT_ICONS[toast.variant]}
          </span>
          <span className={styles.message}>{toast.message}</span>
          <button
            className={styles.dismiss}
            onClick={() => onDismiss(toast.id)}
            aria-label="Fechar notificação"
            type="button"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
